// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"011a98d8","455":"4da0fd0e","977":"ef79e9c5"}[chunkId] + ".chunk.js";
};